import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from '../../core/services/device-detector.service';

@Component({
  selector: 'app-device-detector-component',
  templateUrl: './device-detector-component.component.html',
})
export class DeviceDetectorComponentComponent implements OnInit {
  deviceType: string = '';
  isMobile: boolean = false;
  isDesktop: boolean = false;
  deviceModel: string = '';

  constructor(private readonly deviceService: DeviceDetectorService) {}

  ngOnInit(): void {
    this.deviceType = this.deviceService.getDeviceType();
    this.deviceModel = this.deviceService.getDeviceModel();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop();
  }
}
